import React, { Component } from 'react'

import Scroll from 'react-scroll'

import IndexPage from '../components/_TennisEte'
import SetLanguageFromPage from '../config/i18n/SetLanguageFromPage'

class Index extends Component {
  render() {
    return <IndexPage />
  }
}

export default SetLanguageFromPage()(Index)
